const images = document.querySelectorAll('[data-images-to-observe]');
const config = {
  rootMargin: '50px 0px 50px 0px',
  threshold: 0,
};

/**
 *
 * @param img
 */
const loadImage = (img) => {
  const src = img.getAttribute('data-src');

  src && (img.src = src);
};


/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver
 *
 * @type {IntersectionObserver}
 */
const lazyImageObserver = new IntersectionObserver((entries, self) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      loadImage(entry.target);
      self.unobserve(entry.target);
    }
  });
}, config);


// Run
if (images) {
  Array.prototype.slice.call(images).forEach((image) => {
    lazyImageObserver.observe(image);
  });
}
